"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictionRuleCategoryMinMax = void 0;
const _1 = require("./");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
/**
 * Restriction Rule: CategoryMinMax
 *
 * This rule limits the minimum and/or maximum number of items allowed in a
 * certain category. For example, a burrito product blueprint comes with a
 * “protein“ category which has three available types of protein: beef, pork
 * and lamb. It also comes with a CategoryMinMax restriction rule saying the
 * minimum number of items in the protein category is 1 and the maximum number
 * of items in the protein category is 2. Given such a blueprint, it would be
 * a valid burrito build if the customer chose beef as the base protein and
 * added one extra share of pork, in which case the total number of items in
 * the protein category was 2 hence meeting the restriction rule. On the other
 * hand, given the same blueprint, it would be a invalid burrito build if the
 * customer chose beef as the base protein, but added one extra share of pork
 * and one extra share of lamb, in which case the total number of items in the
 * protein category was 3 hence violating the protein CategoryMinMax
 * restriction rule. It would also be an invalid burrito build if the customer
 * didn’t choose from beef, pork or lamb at all as it violates the minimum part
 * of the restriction rule, i.e. this burrito must have at least one share of
 * protein.
 */
class RestrictionRuleCategoryMinMax {
    constructor(data) {
        this.name = _1.TRestrictionRuleName.categoryMinMax;
        this.min = null;
        this.max = null;
        if (data) {
            this.category = data.category;
            this.min = data.min ? data.min : null;
            this.max = data.max ? data.max : null;
        }
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            name: this.name,
            category: this.category,
            min: this.min,
            max: this.max
        };
    }
    static unserialize(data) {
        const newRestrictionRuleCategoryMinMax = new this();
        newRestrictionRuleCategoryMinMax.category = data.category;
        newRestrictionRuleCategoryMinMax.min = data.min;
        newRestrictionRuleCategoryMinMax.max = data.max;
        return newRestrictionRuleCategoryMinMax;
    }
    isValid(products, productAvailability, selectedProducts) {
        const hitMax = this.hitMax(selectedProducts);
        const hitMin = this.hitMin(selectedProducts);
        const isValid = !hitMax && !hitMin;
        return isValid;
    }
    apply(products, productAvailability, selectedProducts) {
        const hitMax = this.hitMax(selectedProducts, true);
        // const hitMin = this.hitMin(selectedProducts, true);
        if (hitMax) {
            // disable addition of all products in that category once max is hit
            productAvailability.map(pa => {
                const product = products.find(p => p.productId === pa.productId);
                const isFromCategory = product.category.name === this.category;
                if (isFromCategory) {
                    pa.canAdd = false;
                }
            });
        }
        // Requirement update: removal of selected products should be still
        // allowed even if min is hit
        // if (hitMin) {
        //   // disable removal of selected products in that category once min is hit
        //   productAvailability.map(pa => {
        //     const product = products.find(p => p.productId === pa.productId);
        //     const isFromCategory = product.category.name === this.category;
        //     const isSelected = selectedProducts.some(
        //       selectedProduct =>
        //         selectedProduct.product.productId === pa.productId &&
        //         selectedProduct.quantity > 0
        //     );
        //     if (isFromCategory && isSelected) {
        //       pa.canRemove = false;
        //     }
        //   });
        // }
    }
    /**
     * Get the total number of all products in the category specified by the restriction rule.
     */
    getQuantityForCategory(selectedProducts) {
        const selectedInCategory = selectedProducts.filter(p => p.product.category.name === this.category);
        const quantity = selectedInCategory.reduce((total, current) => total + current.quantity, 0);
        return quantity;
    }
    /**
     * Check if the maximum is reached.
     */
    hitMax(selectedProducts, checkBoundary = false) {
        const quantity = this.getQuantityForCategory(selectedProducts);
        if (checkBoundary) {
            return this.max === null ? false : quantity >= this.max;
        }
        else {
            return this.max === null ? false : quantity > this.max;
        }
    }
    /**
     * Check if the minimum is reached.
     */
    hitMin(selectedProducts, checkBoundary = false) {
        const quantity = this.getQuantityForCategory(selectedProducts);
        if (checkBoundary) {
            return this.min === null ? false : quantity <= this.min;
        }
        else {
            return this.min === null ? false : quantity < this.min;
        }
    }
}
exports.RestrictionRuleCategoryMinMax = RestrictionRuleCategoryMinMax;
//# sourceMappingURL=RestrictionRuleCategoryMinMax.js.map